import {SortDirection} from "utils/DBUtils";

class SortManager {
    sorts = {};

    /**
     * Creates a SortManager for give fields
     * @param possibleFields
     */
    constructor(...possibleFields) {
        if (possibleFields) {
            for (let field of possibleFields) {
                this.sorts[field] = SortDirection.Unsorted;
            }
        }
    }

    /**
     * Returns the SortDirection for the given field.
     * Returns Unsorted if field was not provided during construction
     * @param field
     * @returns string
     */
    getSortDirectionForField(field) {
        let sort = this.sorts[field];
        return sort ? sort : SortDirection.Unsorted;
    }

    /**
     * Sets the SortDirection of the given field
     * Does nothing if field was not provided during construction
     * @param field
     * @param sortDirection
     */
    setSortDirectionForField(field, sortDirection) {
        if (this.sorts[field]) {
            this.sorts[field] = sortDirection;
        }
    }

    /**
     * Sets the given field to a SortDirection.
     * If currently Unsorted, its set to Descending
     * else field is toggled between Ascending and Descending
     * Resets all other fields to Unsorted
     * @param field
     */
    toggleSort(field) {
        for (let sortKey of Object.keys(this.sorts)) {
            let sort = this.sorts[sortKey];
            if (sortKey !== field) {
                this.sorts[sortKey] = SortDirection.Unsorted
            } else {
                if (sort === SortDirection.Unsorted) {
                    this.sorts[sortKey] = SortDirection.Descending;
                } else {
                    this.sorts[sortKey] = sort === SortDirection.Descending ? SortDirection.Ascending : SortDirection.Descending;
                }
            }
        }
    }

    /**
     * Creates an array of objects in shape {field: String, direction: String}
     */
    arrayOfSorts() {
        let keys = Object.keys(this.sorts);
        let ary = [];
        for (let key of keys) {
            let sort = this.sorts[key];
            if (sort !== SortDirection.Unsorted) {
                ary.push({
                    field: key,
                    direction: sort
                });
            }
        }
        return ary;
    }
}

export default SortManager;


// WEBPACK FOOTER //
// ./public/classes/SortManager.js